import { render } from "./contract-list-old.vue?vue&type=template&id=1fef533b"
import script from "./contract-list-old.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-list-old.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-list-old.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fef533b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fef533b', __exports__)) {
    api.reload('1fef533b', __exports__)
  }
  
  module.hot.accept("./contract-list-old.vue?vue&type=template&id=1fef533b", () => {
    api.rerender('1fef533b', render)
  })

}


export default __exports__